(() => {
  const body = document.body;
  const preview = body.dataset.krugThemeRole !== 'main' && body.dataset.krugDesignMode !== 'true';
  const id = body.dataset.krugThemeId;
  const hosts = new Set([location.hostname, 'kruggroup.at', 'www.kruggroup.at', 'krugnow.com', 'www.krugnow.com', 'a4dfa2.myshopify.com']);
  function update(link) {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    let url;
    try { url = new URL(href, location.href); } catch { return; }
    if (!/^https?:$/.test(url.protocol) || !hosts.has(url.hostname)) return;
    if (/^\/(admin|account|checkout|checkouts|apps)(\/|$)/.test(url.pathname)) return;
    if (preview && id) {
      url.searchParams.set('preview_theme_id', id);
    }
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }
  function refresh() { document.querySelectorAll('a[href]').forEach(update); }
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('krug:products-updated', refresh);
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (link) update(link);
  }, true);
})();
